import { Icon, IconProps } from "../";

export const MccmLineNotebookCloseIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M19.99 7.93V7.01C19.99 6.81 19.91 6.63 19.81 6.48C19.75 6.35 19.59 6.17 19.51 6.09C19.23 5.8 19.1 5.42 19.1 5.06C19.1 4.66 19.13 4.54 19.36 4.14L19.72 3.66C19.87 3.48 19.97 3.26 19.97 3.01C19.97 2.46 19.52 2 18.97 2H6.99C6.19 2 5.44 2.31 4.88 2.87C4.4 3.35 4.1 3.96 4.02 4.62C4.01 4.69 4 4.76 4 4.83V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7.97C20 7.97 20 7.94 20 7.93H19.99ZM6.29 4.29C6.48 4.1 6.72 4 6.99 4H17.61C17.52 4.33 17.48 4.67 17.48 5.05C17.48 5.38 17.52 5.69 17.59 5.97H6.99C6.45 5.97 6 5.53 6 4.99C6 4.73 6.1 4.48 6.29 4.29ZM17.8 20H6.2C6.09 20 6 19.91 6 19.8V7.8C6.31 7.91 6.64 7.97 6.99 7.97H17.8C17.91 7.97 18 8.06 18 8.17V10.35V19.8C18 19.91 17.91 20 17.8 20Z" />
    </Icon>
  );
};
